import React from "react";
import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";

export const MultiSelectFilter = React.memo(({
    columnId,
    options,
    placeholder,
    columnWidth,
    getFilterValue,
    updateFilterValue,
}) => {

    return (
        <Autocomplete
            multiple
            options={options}
            disableCloseOnSelect
            value={getFilterValue(columnId) || []}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(e, newValue) => {
                updateFilterValue(columnId, newValue);
            }}
            size="small"

            renderOption={(props, option, { selected }) => (
                <li {...props} key={option}>
                    <Checkbox checked={selected} />
                    {option}
                </li>
            )}

            renderTags={(value, getTagProps) =>
                <Chip
                    label={value.length > 1 ? `${value.length} ${columnId}s selected` : value[0]}
                    size="small"
                    sx={{
                        backgroundColor: "gray",
                        color: "white",

                        "& .MuiChip-deleteIcon": {
                            color: "white",
                        },
                    }}
                />
            }

            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    placeholder={placeholder}
                />
            )}

            sx={{
                width: columnWidth || "auto",

                "& .MuiInputBase-input": {
                    color: "white",
                },

                "& .MuiSvgIcon-root": {
                    color: "white",
                },

                "& .MuiInput-underline:before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "white",
                },

                "& .MuiInput-underline:after": {
                    borderBottomColor: "white",
                },
            }}
        />
    );
});


export const HighlightedCell = ({
    value,
    columnId,
    reportListColumnFilters,
    user,
}) => {

    const currentFilter =
        reportListColumnFilters.find(
            (f) => f.id === columnId
        );

    const selectedValues =
        currentFilter?.value || [];

    const normalizedSelectedValues = selectedValues.map((item) => {

        if (item === "@Me") {
            return user?.email;
        }

        if (item === "@Unassigned") {
            return "";
        }

        return item;
    });

    const isMatched =
        Array.isArray(normalizedSelectedValues) &&
        normalizedSelectedValues.includes(value);

    return (
        <span
            style={{
                backgroundColor: isMatched
                    ? "rgb(255, 203, 127)"
                    : "transparent",
                color: isMatched
                    ? "black"
                    : "inherit",
                padding: "2px 4px",
                borderRadius: "4px",
            }}
        >
            {value}
        </span>
    );
};